import { render, staticRenderFns } from "./AllStudents.vue?vue&type=template&id=0f137d82&scoped=true&"
import script from "./AllStudents.vue?vue&type=script&lang=js&"
export * from "./AllStudents.vue?vue&type=script&lang=js&"
import style0 from "./AllStudents.vue?vue&type=style&index=0&id=0f137d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f137d82",
  null
  
)

export default component.exports